// @flow
import React from 'react'

const Status = () => {
  return <p>ok</p>
}

export default Status
